import { IngestColumn } from "datasets/pages/tables/types/interfaces/ingest";

export const normalizeColumnNames = (cols: IngestColumn[]) => {
  return cols.map((col) => ({ ...col, name: col.name.toUpperCase() }));
};
